<template>
  <div>
    <Header></Header>
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner5.png" alt="">-->
<!--    </div>-->
    <div class="contact">
      <div class="title">
        <h3>联系我们 / Contact us</h3>
        <p>有任何需求请与我们联系</p>
      </div>
      <div class="content" v-html="introContent"></div>
<!--      <baidu-map class="map" :center="center" :zoom="zoom" :scroll-wheel-zoom="true">-->
<!--        <bm-marker :position="{lng: 116.332377, lat: 39.888685}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>-->
<!--      </baidu-map>-->
<!--      <div class="contact-detail">-->
<!--        <h3>北京明世继元招标有限公司</h3>-->
<!--        <div class="contact-info">-->
<!--          <div class="contact-info-text">-->
<!--            <img src="@/assets/images/contact-address.png" alt="">-->
<!--            <h4>地址</h4>-->
<!--            <p>北京市西城区马连道路11号一商大厦1503</p>-->
<!--          </div>-->
<!--          <div class="contact-info-text">-->
<!--            <img src="@/assets/images/contact-phone.png" alt="">-->
<!--            <h4>电话</h4>-->
<!--            <p>010-63518887</p>-->
<!--          </div>-->
<!--          <div class="contact-info-text">-->
<!--            <img src="@/assets/images/contact-net.png" alt="">-->
<!--            <h4>网址</h4>-->
<!--&lt;!&ndash;            <p>www.baidu.com</p>&ndash;&gt;-->
<!--          </div>-->
<!--          <div class="contact-info-text">-->
<!--            <img src="@/assets/images/contact-email.png" alt="">-->
<!--            <h4>邮箱</h4>-->
<!--            <p>bjmsjy@163.com</p>-->
<!--          </div>-->
<!--          <div class="contact-info-text">-->
<!--            <img src="@/assets/images/contact-cz.png" alt="">-->
<!--            <h4>传真</h4>-->
<!--            <p> 010-63518887 -86</p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/assets/components/Header'
import Footer from '@/assets/components/Footer'
import axios from "axios";
import url from '@/assets/public/url'
export default {
  name: "Contact",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      center: {lng: 116.332377, lat: 39.888685},
      zoom: 16,
      marker: {lng: 116.332377, lat: 39.888685},
      coverPhoto: '',
      requestUrl: url.url,
      introContent: ''
    }
  },
  methods: {
    getContactContent: function () {
      var self = this
      axios.get(self.requestUrl + '/news/app/newscontent/listpagenewscontentrelease', {
        params: {
          newsDirectoriesId: '69c93d1e-44a4-4664-ad7d-e6ba3bc8e720',
        }
      }).then(function (res) {
        self.getIntroDetail(res.data.rows[0].newsContentId)
      })
    },
    getIntroDetail: function (id) {
      var self = this
      axios.get(self.requestUrl + '/news/app/newscontent/getnewscontentbyidrelease/' + id).then(function (res) {
        self.introContent = res.data.newsContentContent
        self.isLoading = false
      })
    },
  },
  mounted() {
    this.getContactContent()
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~styles/public.styl"
.banner, .banner img
  width 100%
  height 400px
.contact
  width 1200px
  margin 35px auto
  .title
    text-align center
    padding 25px 0
    border-bottom 1px solid $main-blue
    margin-bottom 50px
    h3
      font-size 28px
      color #666
      font-weight normal
      margin-bottom 15px
    p
      font-size 14px
      color #999

  .map
    width 100%
    height 600px
  .contact-detail
    margin-top 60px
    h3
      text-align center
      font-size 18px
      color #333
      margin-bottom 60px
    .contact-info
      overflow hidden
      .contact-info-text
        float left
        width 20%
        text-align center
        padding 0 15px
        box-sizing border-box
        h4
          font-size 20px
          color #666
          margin 50px 0 20px
        p
          font-size 16px
          color #666
          line-height 25px
.content
  min-height 500px
</style>



// WEBPACK FOOTER //
// src/pages/Contact/Contact.vue